<template>
  <div>
    <list v-show="showList" ref="listComponent" @onEdit="handleEdit"></list>
    <edit v-if="!showList" :record="record" @onGoBack="handleGoBack"></edit>
  </div>
</template>

<script>

// 动态切换组件
import List from './DepartmentList'
import Edit from './DepartmentEdit'

export default {
  name: 'DepartmentPage',
  components: {
    List,
    Edit
  },
  data () {
    return {
      record: '',
      // 是否显示List
      showList: true
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.showList = false
    },
    handleGoBack () {
      this.record = ''
      this.$refs.listComponent.refreshCurrentPage()
      this.showList = true
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.showList = true
    }
  }
}
</script>
